{
  "name": "termekmix",
  "config": {
    "ref": "feature-GRBTM-3314-disable-otthon-start",
    "commit": "64aa1ba7",
    "project_api_version": "3.0.0-SNAPSHOT-5",
    "backend_project_id": "55978979"
  },
  "scripts": {
    "ng": "ng",
    "postinstall": "if [[ -z $RELEASE ]] || [[ $RELEASE != 'true' ]]; then npm run generate:api; else echo 'Release CI Job detected. No postinstall required...'; fi",
    "generate:api-remote": "npm run generate:pull-remote-api && ng-openapi-gen --input openapi-web.yml --output shared/openapi --ignoreUnusedModels false && npm run rename-duplicates-in-generated-enum",
    "generate:pull-remote-api": "curl https://gitlab.com/api/v4/projects/$npm_package_config_backend_project_id/packages/generic/api/$npm_package_config_project_api_version/openapi-web.yml -u $DOCKER_REGISTRY_USERNAME:$DOCKER_REGISTRY_PASSWORD -s > openapi-web.yml",
    "generate:api": "cd .. && cd api/generate && npm run generate:api-web && cd ../.. && cd frontend && ng-openapi-gen --input ../api/openapi-web.yml --output shared/openapi --ignoreUnusedModels false && npm run rename-duplicates-in-generated-enum",
    "check:all": "npm run check:admin && npm run check:client && npm run check:partner && npm run check:shared",
    "fix:all": "npm run fix:admin && npm run fix:client && npm run fix:partner && npm run fix:shared",
    "build": "npm run build:admin && npm run build:client && npm run build:partner",
    "check:shared": "npx prettier --check shared && npx eslint shared",
    "fix:shared": "npx prettier --write shared && npx eslint --fix shared --cache",
    "start:admin": "npm run copy-assets -- --project=admin && ng serve --port 4201 --project admin --proxy-config shared/configs/proxy.conf.json --configuration=development",
    "check:admin": "npx prettier --check projects/admin && npx ng lint admin",
    "fix:admin": "npx prettier --write projects/admin && npx ng lint --fix admin --cache",
    "analyze-bundle:admin": "ng build --project admin --stats-json && webpack-bundle-analyzer ./dist/admin/stats.json",
    "start:client": "npm run copy-assets -- --project=client && ng serve --port 4202 --project client --proxy-config shared/configs/proxy.conf.json --configuration=development",
    "check:client": "npx prettier --check projects/client && npx ng lint client",
    "fix:client": "npx prettier --write projects/client && npx ng lint --fix client --cache",
    "analyze-bundle:client": "ng build --project client --stats-json && webpack-bundle-analyzer ./dist/client/stats.json",
    "start:partner": "npm run copy-assets -- --project=partner && ng serve --port 4203 --project partner --proxy-config shared/configs/proxy.conf.json --configuration=development",
    "check:partner": "npx prettier --check projects/partner && npx ng lint partner",
    "fix:partner": "npx prettier --write projects/partner && npx ng lint --fix partner --cache",
    "analyze-bundle:partner": "ng build --project partner --stats-json && webpack-bundle-analyzer ./dist/partner/stats.json",
    "copy-assets": "node shared/scripts/assets-copy",
    "rename-duplicates-in-generated-enum": "node shared/scripts/rename-duplicates-in-generated-enum",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "start:tunnel": "node shared/scripts/start-tunnel.js",
    "start:client-tunnel": "node shared/scripts/start-client-tunnel.js",
    "build:client": "npm run copy-assets -- --project=client && ng build --project client",
    "build:client:aws": "npm run copy-assets -- --project=client && ng build --project client --configuration=manual",
    "build:admin": "npm run copy-assets -- --project=admin && ng build --project admin",
    "build:admin:aws": "npm run copy-assets -- --project=admin && ng build --project admin --configuration=manual",
    "build:partner": "npm run copy-assets -- --project=partner && ng build --project partner",
    "build:partner:aws": "npm run copy-assets -- --project=partner && ng build --project partner --configuration=development",
    "storybook": "ng run storybook:storybook",
    "build-storybook": "ng run storybook:build-storybook",
    "start:client-with-storybook": "npm run build-storybook && npm run start:client && ng serve --port 4202 --project client --proxy-config shared/configs/proxy.conf.json --configuration=development"
  },
  "private": true,
  "engines": {
    "node": ">=22.12.0 <24.11.0"
  },
  "dependencies": {
    "@angular/animations": "^20.3.10",
    "@angular/cdk": "20.2.12",
    "@angular/common": "^20.3.10",
    "@angular/compiler": "^20.3.10",
    "@angular/core": "^20.3.10",
    "@angular/forms": "^20.3.10",
    "@angular/material": "20.2.12",
    "@angular/platform-browser": "^20.3.10",
    "@angular/platform-browser-dynamic": "^20.3.10",
    "@angular/router": "^20.3.10",
    "@ngrx/store": "^20.1.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "date-fns": "^3.6.0",
    "dayjs": "^1.11.13",
    "file-saver": "^2.0.5",
    "heic2any": "^0.0.4",
    "keycloak-angular": "^20.0.0",
    "keycloak-js": "^24.0.5",
    "marked": "^15.0.12",
    "material-icons": "^1.13.14",
    "ng-recaptcha-2": "^16.0.1",
    "ngx-cookie-service": "^20.1.1",
    "ngx-device-detector": "^10.1.0",
    "ngx-logger": "^5.0.12",
    "ngx-mask": "^17.1.8",
    "ngx-mat-select-search": "^8.0.3",
    "qrcode": "^1.5.4",
    "rxjs": "^7.8.2",
    "tslib": "^2.6.2",
    "uuid": "^10.0.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.9",
    "@angular-eslint/builder": "^18.4.3",
    "@angular-eslint/eslint-plugin": "^18.4.3",
    "@angular-eslint/eslint-plugin-template": "^18.4.3",
    "@angular-eslint/schematics": "^18.4.3",
    "@angular-eslint/template-parser": "^18.4.3",
    "@angular/cli": "^20.3.9",
    "@angular/compiler-cli": "^20.3.10",
    "@compodoc/compodoc": "^1.1.32",
    "@storybook/addon-docs": "^10.0.8",
    "@storybook/angular": "^10.0.8",
    "storybook": "^10.0.8",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "^5.1.8",
    "@types/node": "^20.19.0",
    "@types/qrcode": "^1.5.5",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "autoprefixer": "^10.4.21",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^9.1.0",
    "eslint-import-resolver-typescript": "^3.10.1",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jsdoc": "^46.10.1",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^5.4.1",
    "eslint-plugin-unused-imports": "^3.2.0",
    "gzipper": "^7.2.0",
    "jasmine-core": "^5.8.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "lint-staged": "^15.5.2",
    "msw": "^2.10.2",
    "ng-openapi-gen": "^0.51.0",
    "postcss": "^8.5.5",
    "prettier": "^3.5.3",
    "tailwindcss": "^3.4.17",
    "typescript": "^5.8.3",
    "webpack-bundle-analyzer": "^4.10.2"
  }
}
